import { Box, BoxProps } from '@chakra-ui/react';
import { mergeWith } from '@chakra-ui/utils';
import React from 'react';

import { useMultiStyleConfig } from '../../system/hooks';

import { SideBarContextProvider } from './SideBarContext';
import DisplayNames from './enums';

export type SideBarProps = BoxProps;

const SideBarView = (props: SideBarProps): React.ReactElement => {
  const { sideBar } = useMultiStyleConfig('SideBar', props);
  const { __css } = props;

  return <Box __css={mergeWith(sideBar, __css)} as="aside" {...props} />;
};

SideBarView.propTypes = {};

const SideBar = (props: SideBarProps): React.ReactElement => {
  return (
    <SideBarContextProvider>
      <SideBarView {...props} />
    </SideBarContextProvider>
  );
};

SideBar.displayName = DisplayNames.SideBar;

export default React.memo(SideBar);
